var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",null,{"disabled":_vm.disabled,"onClick":_vm.onExport})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }